import { doc, setDoc, increment } from 'firebase/firestore';
import { db } from '../firebase';

const LEVEL_MULT = { N5: 1, N4: 1.2, N3: 1.5, N2: 2, N1: 3 };

export const calcXP = {
  vocab:   (level) => Math.round(2 * (LEVEL_MULT[level] || 1)),
  kanji:   (level) => Math.round(3 * (LEVEL_MULT[level] || 1)),
  grammar: (level) => Math.round(2 * (LEVEL_MULT[level] || 1)),
  reading: (level) => Math.round(5 * (LEVEL_MULT[level] || 1)),
  drill:   ()      => 3,
  quiz:    (pct)   => Math.min(Math.round(pct), 100),
  streak:  ()      => 10,
};

export async function awardXP(uid, xpGain, nickname) {
  if (!uid || xpGain <= 0) return;
  const name = nickname || 'Explorer';
  await Promise.all([
    setDoc(doc(db, 'users', uid), { xp: increment(xpGain) }, { merge: true }),
    setDoc(doc(db, 'leaderboard', uid), { xp: increment(xpGain), nickname: name, updatedAt: Date.now() }, { merge: true }),
  ]);
}
